module.exports = __webpack_public_path__ + "static/media/webpay_transbank.23354a80.jpg";